import { CheckCircle2, CircleAlert } from "lucide-react";
import type { ModelCurrencyOverview } from "@/services/adminModelCurrency";
import { attentionCounts, attentionSummary } from "./layoutHelpers";

/** One line saying what needs a decision, before the per-feature detail. */
const AttentionSummary = ({ overview }: { overview: ModelCurrencyOverview }) => {
  const counts = attentionCounts(overview);
  const clear = counts.ready + counts.waiting + counts.failed === 0;
  const Icon = clear ? CheckCircle2 : CircleAlert;
  return (
    <p className="flex items-center gap-2 text-sm font-medium">
      <Icon
        className={clear ? "h-4 w-4 text-emerald-600" : "h-4 w-4 text-amber-600"}
        aria-hidden="true"
      />
      {attentionSummary(counts)}
    </p>
  );
};

export default AttentionSummary;
